import { ArrowUpDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu.tsx";
import { DataTableCenteredCell } from "@/shared/ui/DataTable";
import { Button } from "@/shared/ui/button.tsx";
import { HoverCardInfo } from "@/features/HoverCardInfo";
import { useURLParamsData } from "@/shared/hooks/useURLParamsData.ts";
import { localizationMap } from "@/shared/lib/consts";
import { CandidateStatus } from "@/entities/candidate/model";

type StatusOption = {
  value: CandidateStatus | null;
  label: string;
};

const statusOptions: StatusOption[] = [
  { value: null, label: "Все статусы" },
  { value: CandidateStatus.Approved, label: "Одобрено" },
  { value: CandidateStatus.Pending, label: "В ожидании" },
  { value: CandidateStatus.Rejected, label: "Отклонен" },
];

export const CandidateStatusDropdown = () => {
  const { candidateStatus, setCandidateStatus } = useURLParamsData();

  return (
    <DropdownMenu>
      <DataTableCenteredCell className="flex flex-row">
        <DropdownMenuTrigger asChild>
          <Button className="text-thColor" variant="ghost">
            <p>
              {candidateStatus
                ? localizationMap[candidateStatus.toLowerCase()] ||
                  candidateStatus
                : "Статус"}
            </p>
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
      </DataTableCenteredCell>
      <DropdownMenuContent>
        {statusOptions.map(({ value, label }) => (
          <DropdownMenuItem
            key={value ?? "null"}
            className="overflow-y-auto"
            onClick={() => setCandidateStatus(value)}
          >
            {value ? (
              <HoverCardInfo text={label}>{label}</HoverCardInfo>
            ) : (
              label
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
